import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import "./pages/portal.css";
import "./pages/user-admin.css";
import "./pages/manage-bu.css";
import "./pages/add-client.css";
import "./pages/edit-client.css";
import "./pages/manage-client.css";
import "./pages/manage-event.css";
import "./pages/manage-element.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import DualApp from "./DualApp";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <DualApp />
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
